import { Col, Row, Typography, Table, Form, Switch } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaSwitch } from "apps/Common/MazakaSwitch";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";

import useMazakaForm from "hooks/useMazakaForm";
import { useEffect, useRef, useState } from "react";
import { getUserPermissions, updateUserPermissions } from "../Services";
import PageTitle from "apps/Common/PageTitle";
import useWindowSize from "helpers/useWindowSize";
import { Helmet } from "react-helmet-async";

const Allows = () => {
  const { Text } = Typography;
  const [form] = Form.useForm();
  const { mazakaForm, formActions } = useMazakaForm(form);
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const containerRef = useRef(null);
  const windowSize = useWindowSize();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // HATA 1: useEffect dependency eksik - windowSize.width değiştiğinde çalışmıyor
  useEffect(() => {
    if (windowSize.width < 1040) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  }, [windowSize.width]); // Dependency eklendi

  const getPermissions = async () => {
    setIsLoading(true);
    try {
      const response: any = await getUserPermissions();

      if (response?.data) {
        setData(response.data);
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message || "");
      console.log("Somethings wrong during login to dashboard", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
  }, []);

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    try {
      const response = await updateUserPermissions(data);
      mazakaForm.setSuccess(
        1000,
        () => response.message || "Kayıt olma işlemi Başarılı"
      );
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
      openNotificationWithIcon("default", error?.message || "");
      console.log("Somethings wrong during login to dashboard", error);
    }
  };

  const handleSwitchChange = (
    key: string,
    value: boolean,
    propertyName: string,
    mode: "mobile" | "desktop" = "desktop"
  ) => {
    setData((prevData) => {
      const newData = prevData.map((item, index) => {
        if (mode === "mobile" && (index === 1 || index === 2)) {
          // HATA 2: Bu mantık yanlış - permission id'ye göre güncelleme yapmalı
          return { ...item, [propertyName]: value };
        }
        // Eğer mode "desktop" ise sadece key eşleşen elemanı güncelle
        return item.permission?.id === key || item.permissionId === key
          ? { ...item, [propertyName]: value }
          : item;
      });

      return newData;
    });
  };

  const columns = [
    {
      title: "Bildirim",
      dataIndex: ["permission", "name"],
      key: "notificationTitle",
      render: (title: string, record: any) => {
        return (
          <>
            <div className="!flex flex-col gap-3 !w-full">
              <div>
                <Text className="!text-xs md:!text-sm"> {title} </Text>
              </div>
              <div className="xl:!hidden !w-full !flex !flex-col gap-4">
                <div className="!flex justify-between items-center !w-full">
                  <div>
                    <Text> SMS</Text>
                  </div>
                  <Switch
                    className="mobile-label"
                    checked={record?.isMobile}
                    onChange={(value: boolean) =>
                      handleSwitchChange(
                        record.permission?.id || record.permissionId,
                        value,
                        "isMobile",
                        "mobile"
                      )
                    }
                  />
                </div>
                <div className="!flex justify-between">
                  <div>
                    <Text>E-Posta</Text>
                  </div>
                  <Switch
                    checked={record?.isEmail}
                    onChange={(value: boolean) =>
                      handleSwitchChange(
                        record.permission?.id || record.permissionId,
                        value,
                        "isEmail",
                        "mobile"
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </>
        );
      },
    },
    ...(isSmallScreen ? [] : [
      {
        title: "SMS",
        dataIndex: "isMobile",
        key: "mobile",
        render: (checked: boolean, record: any) => (
          <div className="gap-2 items-center !hidden xl:!flex">
            <MazakaSwitch
              className="mobile-label"
              checked={checked} // HATA 3: defaultChecked yerine checked kullan
              onChange={(value: boolean) =>
                handleSwitchChange(
                  record.permission?.id || record.permissionId,
                  value,
                  "isMobile"
                )
              }
            />
          </div>
        ),
      },
      {
        title: "E-Posta",
        dataIndex: "isEmail",
        key: "email",
        render: (checked: boolean, record: any) => (
          <div className="!hidden xl:!block">
            <MazakaSwitch
              checked={checked} // HATA 3: defaultChecked yerine checked kullan
              onChange={(value: boolean) =>
                handleSwitchChange(
                  record.permission?.id || record.permissionId,
                  value,
                  "isEmail"
                )
              }
            />
          </div>
        ),
      },
    ])
  ];

  return (
    <>
      <Col xs={24} ref={containerRef}>
        <Helmet>
          <title className="capitalize">{"Bildirim Listesi"}</title>
        </Helmet>
        <MazakaForm
          onFinish={handleOnFinish}
          form={form}
          submitButtonVisible={false}
        >
          <Row
            gutter={[
              { xs: 10, md: 10, xl: 10 },
              { xs: 10, md: 15, xl: 20 },
            ]}
            className=""
          >
            <Col span={24}>
              <Table
                loading={isLoading}
                dataSource={data} // HATA 4: Koşullu filtreleme kaldırıldı
                columns={columns}
                pagination={false}
                bordered
                rowClassName="responsive-row"
                rowKey={(record) => record.permission?.id || record.permissionId || record.id}
              />
            </Col>

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black !mt-4"
                htmlType="submit"
                processType={formActions.submitProcessType}
              >
                Kaydet
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default Allows;